<template>
    <section>
        <div>
            <b-modal :active="isModalCofirmDeleteCommitment" aria-modal has-modal-card :destroy-on-hide="true"
                aria-role="dialog" width="100%" :can-cancel="['escape']">
                <template>
                    <ConfirmDeleteCommitment modal-cancel="true" :commitment="commitmentToDelete"
                        @close="isModalCofirmDeleteCommitment = false" @delete="deletePerformance()" />
                </template>
            </b-modal>
        </div>
        <div class="title is-5 has-text-centered">
            Agregar Actividad Académica y Hora al Compromiso
            <hr class="dropdown-divider" aria-role="menuitem">
        </div>
        <ValidationObserver ref="observer" id="form-commitment">
            <div class="columns">
                <div class="column">
                    <b-field label="Actividad Académica *">
                        <ValidationProvider name="Actividad Académica" rules="required" v-slot="{ errors }">
                            <multiselect v-model="selected_academic_activity"
                                :options="academicArea.academic_activities" searchable
                                :custom-label="opt => opt.alt_name" placeholder="Seleccione una Actividad"
                                selectLabel="Presione para seleccionar" selectedLabel="Seleccionado" deselectLabel=""
                                :allow-empty="false">
                                <template v-slot:noOptions> No hay datos. </template>
                                <template v-slot:noResult> No se han encontrado resultados
                                    para su
                                    búsqueda, pruebe con otra. </template>
                            </multiselect>
                            <span class="validation-alert">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </b-field>
                </div>
            </div>

            <div class="columns">
                <div class="column is-narrow">
                    <b-field label="Seleccione el tipo de hora a comprometerse">
                        <br>
                        <b-radio-button v-model="isWeekly" :native-value="true" type="is-primary">
                            <span>Horas Semanales</span>
                        </b-radio-button>
                        <b-radio-button v-model="isWeekly" :native-value="false" type="is-primary">
                            <span>Horas Semestrales</span>
                        </b-radio-button>

                    </b-field>
                </div>

                <div class="column">
                    <b-field label="Horas que comprometo a realizar 1er Semestre *">
                        <ValidationProvider name="Horas que Comprometo a Realizar Primer Semestre"
                            rules="double:1|max:255|min_double|required" v-slot="{ errors }">
                            <b-input v-model="hours_committed_semester_1" placeholder="Ej: 5.5 o 1.2" />
                            <span class="validation-alert">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </b-field>
                </div>

                <div class="column">
                    <b-field label="Horas que comprometo a realizar 2do Semestre *">
                        <ValidationProvider name="Horas que Comprometo a Realizar Segundo Semestre"
                            rules="double:1|max:255|min_double|required" v-slot="{ errors }">
                            <b-input v-model="hours_committed_semester_2" placeholder="Ej: 5.5 o 1.2" />
                            <span class="validation-alert">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </b-field>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <b-field label="Observaciones">
                        <ValidationProvider name="Observaciones" rules="max:500|min:3" v-slot="{ errors }">
                            <b-input v-model="observations" placeholder="Ej: Observaciones" type="textarea" />
                            <span class="validation-alert">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </b-field>
                </div>
            </div>

            <div class="columns">
                <div class="column has-text-right">
                    <b-button v-if="commitmentId" label="Guardar Edición del Compromiso" type="is-warning"
                        icon-left="edit" @click="checkEdit()" />
                    <b-button v-else label="Agregar Actividad al Compromiso" type="is-success" icon-left="plus"
                        @click="checkAdd()" />
                </div>
            </div>
        </ValidationObserver>

        <div class="title is-5 has-text-centered">
            Actividades y Horas Comprometidas
            <hr class="dropdown-divider" aria-role="menuitem">
        </div>

        <div class="columns">
            <div class="column has-text-right">
                <b-button :label="openedDetail.length === 0 ? 'Expandir Observaciones' : 'Contraer Observaciones'"
                    :icon-left="openedDetail.length === 0 ? 'plus-circle' : 'minus-circle'"
                    type="is-blue-color"
                    @click="openedDetail.length === 0 ? openedDetail = performances : openedDetail = []" />
            </div>
        </div>

        <b-table striped :data="performances.filter(x => x.alt_name_area === academicArea.alt_name)" paginated
            per-page=10 :pagination-simple=false pagination-position="bottom" aria-next-label="Siguiente"
            aria-previous-label="Anterior" aria-page-label="Página" aria-current-label="Página actual"
            detail-icon="plus-circle" :opened-detailed="openedDetail" detailed>
            <b-table-column field="commitment_index" label="N°" width="5%" v-slot="props">
                {{ props.row.commitment_index }}
            </b-table-column>
            <b-table-column field="alt_name_activity" label="Actividad Académica" v-slot="props">
                {{ props.row.alt_name_activity }}
            </b-table-column>
            <b-table-column field="is_weekly_hours" label="Tipo de Hora" v-slot="props">
                {{ props.row.is_weekly_hours ? 'Semanales' : 'Semestrales' }}
            </b-table-column>
            <b-table-column field="hours_committed_semester_1" label="Horas 1er Semestre" v-slot="props">
                {{ props.row.hours_committed_semester_1 }}
            </b-table-column>
            <b-table-column field="hours_committed_semester_2" label="Horas 2do Semestre" v-slot="props">
                {{ props.row.hours_committed_semester_2 }}
            </b-table-column>
            <b-table-column label="Acciones" width="25%" v-slot="props">
                <b-button label="Editar" icon-left="edit" type="is-warning" @click="editPerformance(props.row)" />
                <b-button icon-left="trash" type="is-danger" @click="confirmDelete(props.row)" />
            </b-table-column>
            <template #detail="props">
                <div class="content">
                    <p>
                        <b>Observaciones:</b>
                        {{ props.row.observations }}
                    </p>
                </div>
            </template>
            <template slot="empty" slot-scope="props">
                <div class="columns is-centered">
                    <div class="column is-6 is-centered has-text-centered">
                        <b-message type="is-warning">
                            Aun no ha agregado Compromisos de Desempeño para {{ academicArea.alt_name }}, a
                            medida que
                            agregue se iran mostrando en esta tabla.
                        </b-message>
                    </div>
                </div>
            </template>
        </b-table>
        <b-loading is-full-page v-model="isLoading" />
    </section>
</template>

<script>
import axios from 'axios';
import ConfirmDeleteCommitment from './ConfirmDeleteCommitment.vue';
export default {

    props: {
        academicArea: {
            type: Object,
            required: true
        },
        performances: {
            type: Array,
            required: true
        },
    },

    components: {
        ConfirmDeleteCommitment
    },

    data() {
        return {
            isLoading: false,
            isModalCofirmDeleteCommitment: false,
            commitmentToDelete: null,
            openedDetail: [],
            isEditing: false,

            //Datos a guardar
            selected_academic_activity: null,
            isWeekly: true,
            hours_committed_semester_1: null,
            hours_committed_semester_2: null,
            observations: null,
            commitmentId: null,
            commitment_index: null,
        }
    },

    methods: {
        async checkAdd() {
            let valid = await this.$refs.observer.validate()
            if (!valid) {
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Algunos campos presentan errores.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return
            }

            this.$refs.observer.reset()
            this.addCommitment()
        },

        async addCommitment() {
            this.isLoading = true
            let commitment = {
                hours_committed_semester_1: this.hours_committed_semester_1,
                hours_committed_semester_2: this.hours_committed_semester_2,
                is_weekly_hours: this.isWeekly,
                academic_area_id: this.academicArea.id,
                alt_name_area: this.academicArea.alt_name,
                alt_name_activity: this.selected_academic_activity.alt_name,
                academic_activity_id: this.selected_academic_activity.id,
                observations: this.observations,
                commitment_index: this.commitment_index ? this.commitment_index : this.performances.length + 1,
            }

            await axios
                .post('/performances/add-commitment.json', commitment)
                .then((response) => {
                    commitment.id = response.data.id
                    this.$emit('addCommitment', commitment)

                    this.hours_committed_semester_1 = null
                    this.hours_committed_semester_2 = null
                    this.isWeekly = true
                    this.selected_academic_activity = null
                    this.observations = null
                    this.commitment_index = null
                    this.$buefy.toast.open({
                        message: 'Se ha Agregado la Actividad al Compromiso',
                        type: 'is-success'
                    })
                })
                .catch((error) => {
                    const errorMsg = error.response.data.errors ? error.response.data.errors : 'Ha ocurrido un error al intentar guardar el compromiso.'
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: errorMsg,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        async checkEdit() {
            let valid = await this.$refs.observer.validate()
            if (!valid) {
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Algunos campos presentan errores.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return
            }

            this.$refs.observer.reset()
            this.editCommitment()
        },

        async editCommitment() {
            this.isLoading = true
            let commitment = {
                hours_committed_semester_1: this.hours_committed_semester_1,
                hours_committed_semester_2: this.hours_committed_semester_2,
                is_weekly_hours: this.isWeekly,
                academic_area_id: this.academicArea.id,
                alt_name_area: this.academicArea.alt_name,
                alt_name_activity: this.selected_academic_activity.alt_name,
                academic_activity_id: this.selected_academic_activity.id,
                observations: this.observations,
                commitment_index: this.commitment_index ? this.commitment_index : this.performances.length + 1,
                id: this.commitmentId,
            }

            await axios
                .put('/performances/edit-commitment.json', commitment)
                .then((response) => {
                    commitment.id = response.data.id
                    this.$emit('addCommitment', commitment)

                    this.hours_committed_semester_1 = null
                    this.hours_committed_semester_2 = null
                    this.isWeekly = true
                    this.selected_academic_activity = null
                    this.observations = null
                    this.commitment_index = null
                    this.commitmentId = null

                    this.$buefy.toast.open({
                        message: 'Se ha Editado la Actividad del Compromiso',
                        type: 'is-success'
                    })
                })
                .catch((error) => {
                    console.log(error)
                    const errorMsg = error.response.data? error.response.data : 'Ha ocurrido un error al intentar guardar el compromiso.'
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: errorMsg,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isEditing = false
                    this.isLoading = false
                })
        },

        confirmDelete(commitment) {
            this.commitmentToDelete = commitment
            this.isModalCofirmDeleteCommitment = true
        },

        async deletePerformance() {
            this.isLoading = true
            await axios
                .delete(`/activity_performances/${this.commitmentToDelete.id}.json`, this.commitmentToDelete)
                .then((response) => {
                    this.$emit('refreshPerfomance', this.commitmentToDelete, true)

                    this.$buefy.dialog.alert({
                        title: 'Éxito',
                        message: 'Se ha eliminado el compromiso de su declaración.',
                        type: 'is-success',
                        hasIcon: true,
                        icon: 'check-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .catch((error) => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Ha ocurrido un error al eliminar el compromiso.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false
                    this.commitmentToDelete = null
                })

        },

        async editPerformance(commitment) {
            if (this.isEditing) {
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: `Ya esta editando el compromiso ${this.commitment_index}. Guarde la edición para continuar.`,
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return
            } else {
                this.isEditing = true
            }
            this.$emit('refreshPerfomance', commitment, false)

            this.hours_committed_semester_1 = String(commitment.hours_committed_semester_1)
            this.hours_committed_semester_2 = String(commitment.hours_committed_semester_2)
            this.isWeekly = commitment.is_weekly_hours
            this.selected_academic_activity = this.academicArea.academic_activities.find((activity) => activity.id === commitment.academic_activity_id)
            this.observations = commitment.observations
            this.semester = commitment.semester
            this.commitmentId = commitment.id
            this.commitment_index = commitment.commitment_index
            let element = document.getElementById("form-commitment");
            if (element) {
                await setTimeout(() => { }, 50);
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }
}
</script>